import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b9e879d6")

_pushScopeId("data-v-b9e879d6")
const _hoisted_1 = { class: "w-full md:w-3/5 space-y-4 overflow-hidden" }
const _hoisted_2 = { class: "pt-4" }
const _hoisted_3 = { class: "h-screen overflow-y-auto pt-2 pb-88" }
const _hoisted_4 = { class: "pt-4 text-16px text-black-lp-300 font-semibold" }
const _hoisted_5 = { class: "flex flex-col gap-3 md:grid md:gap-6 md:grid-cols-2" }
const _hoisted_6 = { class: "download-request" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_card_report = _resolveComponent("card-report")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_ModalDownload = _resolveComponent("ModalDownload")!
  const _component_DownloadRequest = _resolveComponent("DownloadRequest")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      displayBack: false,
      verticalSeparator: false,
      customClass: "px-0 flex justify-center",
      title: _ctx.$t('report.title'),
      fullPage: ""
    }, {
      data: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_Search, {
              onInput: _ctx.onSearch,
              onClear: _ctx.onClearSearch,
              value: _ctx.searchValue,
              placeholder: _ctx.$t('report.searchByName'),
              class: "w-full"
            }, null, 8, ["onInput", "onClear", "value", "placeholder"])
          ]),
          (!_ctx.reportListData.length)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 0,
                errorType: "notfound"
              }))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reportListData, (item, index) => {
              return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                (item.totalCard)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode("p", _hoisted_4, _toDisplayString(item.title), 1),
                      _createVNode("div", _hoisted_5, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.detail, (e, i) => {
                          return (_openBlock(), _createBlock(_Fragment, { key: i }, [
                            (e.permission)
                              ? (_openBlock(), _createBlock(_component_card_report, {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.onModalDownload(e)),
                                  title: item.title,
                                  description: e.title,
                                  color: e.color
                                }, null, 8, ["onClick", "title", "description", "color"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_ModalDownload, {
      modelValue: _ctx.isModalDownload,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isModalDownload = $event)),
      data: _ctx.detailData
    }, null, 8, ["modelValue", "data"]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_DownloadRequest)
    ])
  ], 64))
})